import { render, staticRenderFns } from "./AreaFilter.vue?vue&type=template&id=4ef7d7c0&scoped=true&"
import script from "./AreaFilter.vue?vue&type=script&lang=js&"
export * from "./AreaFilter.vue?vue&type=script&lang=js&"
import style0 from "./AreaFilter.vue?vue&type=style&index=0&id=4ef7d7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7d7c0",
  null
  
)

export default component.exports